'use strict';

exports.__esModule = true;
exports.create = create;

var _apiClient = require('./../network/api-client');

var _apiClient2 = _interopRequireDefault(_apiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API = {
  PROMOTIONS: '/customer/promotions'
};

exports.default = {
  create: create
};
function create(code) {
  return _apiClient2.default.post({
    route: API.PROMOTIONS,
    data: { code: code }
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/customer/promotions.js
// module id = 1095
// module chunks = 0